module.exports = __webpack_public_path__ + "static/media/mobile-alt.b4af99da.svg";